<template>
  <header class="page__title" :class="[$pageInfo.headerClasses, { center: $pageInfo.isTitleCentered }]">
    <page-back v-if="showBack" class="hidden-mobile" />

    <img
      v-if="(imageSrc || $pageInfo.pageTitleImageSrc) && !$pageInfo.hideLogo"
      class="company-logo"
      :src="imageSrc || $pageInfo.pageTitleImageSrc"
      alt="company logo"
    >

    <h1
      v-if="title || $pageInfo.title"
      class="h5 -t_bold"
      :style="{'--eco-title-span-color': $pageInfo.titleSpanColor }"
      v-html="title || $t($pageInfo.title, $pageInfo.titleParams)"
    >
    </h1>

    <p
      v-if="subTitle || $pageInfo.subTitle" class="page__subtitle t3 -t_medium"
      v-html="subTitle || $t($pageInfo.subTitle, $pageInfo.subTitleParams)"
    ></p>
  </header>
</template>

<script>
import PageBack from './PageBack.vue';

export default {
  name: 'PageTitle',

  components: {
    PageBack,
  },

  props: {
    title: {
      type: String,
      default: undefined,
    },
    subTitle: {
      type: String,
      default: undefined,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.page__title {
  color: $context-color-1;
  margin-bottom: map-get($sh-spacers-wuk, 4);

  h1 {
    margin: map-get($sh-spacers-wuk, 0);
    white-space: pre-line;
    ::v-deep {
      span {
        color: var(--eco-title-span-color, $primary-color);
      }
    }
  }

  @media screen and (min-width: $tablet-size) {
    &.center {
      text-align: center;
    }
  }

  .company-logo {
    display: block;
    max-width: 10.5rem; // ~170px
    max-height: 2.5rem;
    margin-bottom: 1rem;
  }
}

.page__subtitle {
  margin: map-get($sh-spacers-wuk, 0);
  margin-top: map-get($sh-spacers-wuk, 2);
}
</style>
